import { HTMLAttributes, ReactNode, useState } from 'react'
import { Link } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

import { Button } from '@/components/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/dialog'
import { ScrollArea } from '@/components/scroll-area'

interface ConfirmTerms extends HTMLAttributes<HTMLDivElement> {
  setAccepted: () => void
}

interface RootProps extends HTMLAttributes<HTMLDivElement> {
  title?: string
  children: ReactNode
  className?: string
}

function TermsText({ title, children, className }: RootProps) {
  return (
    <>
      <p className="mb-2 font-bold">{title}</p>

      <div className={twMerge('font-normal text-monochromatic-500', className)}>
        <p className="mb-4 text-base">{children}</p>
      </div>
    </>
  )
}

export function ModalTerms({ setAccepted }: ConfirmTerms) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <span className="ml-1 mr-1 cursor-pointer text-bios-primary hover:underline">
          Termos de Serviço e Politica de privacidade
        </span>
      </DialogTrigger>
      <DialogContent>
        <ScrollArea className="mt-10 w-full px-3 md:mt-12">
          <DialogHeader>
            <DialogTitle className="mb-6 text-start text-xl font-medium text-bios-500">
              Termos e condições de uso do site ou blog
            </DialogTitle>
          </DialogHeader>
          <DialogDescription className="text-base">
            <p className="font-bold uppercase">Introdução</p>
            <TermsText>
              Por favor, leia atentamente esta
              <label className="font-bold"> Política de Privacidade </label>
              para que possa conhecer como e com quais finalidades seus Dados
              Pessoais podem ser coletados pela
              <label className="font-bold">
                {' '}
                6BIOS – TECNOLOGIAS AMBIENTAIS SA{' '}
              </label>
              e suas filiais.
            </TermsText>
            <TermsText>
              Acessando os portais eletrônicos da
              <label className="font-bold">
                {' '}
                6BIOS – TECNOLOGIAS AMBIENTAIS SA,{' '}
              </label>
              você deverá analisar a{' '}
              <label className="font-bold">Política de Privacidade</label>{' '}
              nele(s) disposta(s) de modo a conferir sua livre e expressa
              concordância com os termos estipulados, sendo que, caso não esteja
              de acordo com tais diretivas, deverá descontinuar o seu acesso.
            </TermsText>
            <TermsText title="1. DAS INFORMAÇÕES GERAIS">
              1.1. A presente
              <label className="font-bold"> Política de Privacidade</label> tem
              por finalidade demonstrar o compromisso da
              <label className="font-bold">
                {' '}
                6BIOS – TECNOLOGIAS AMBIENTAIS SA{' '}
              </label>
              com a privacidade e a proteção dos dados pessoais coletados de
              seus <label className="font-bold">usuários,</label> por meio dos
              PORTAIS da{' '}
              <Link
                to="https://www.6bios.com/pt/"
                target="_blank"
                className="font-bold underline"
              >
                www.6bios.com
              </Link>
              , estabelecendo regras de coleta, armazenamento, compartilhamento,
              tratamento, finalidade, enriquecimento e eliminação dos dados, de
              forma total ou parcial, automatizados ou não, coletados dentro do
              escopo dos serviços e funcionalidades dos PORTAIS da{' '}
              <Link
                to="https://www.6bios.com/pt/"
                target="_blank"
                className="font-bold underline"
              >
                www.6bios.com
              </Link>
              , de acordo com as leis vigentes.
            </TermsText>
            <TermsText>
              1.2. A
              <label className="font-bold">
                {' '}
                6BIOS – TECNOLOGIAS AMBIENTAIS SA{' '}
              </label>
              é proprietária da Plataforma 6BIOS e está comprometida e adequada
              à Lei n.º 13.709/18 - Lei Geral de Proteção de Dados, que preserva
              a transparência e o respeito para com todos os seus usuários, que
              passa a ser nomeada neste momento como CONTROLADORA.
            </TermsText>
            <TermsText>
              1.3. Essa
              <label className="font-bold"> Política de Privacidade </label>
              poderá ser atualizada em decorrência de eventual normativa, razão
              pela qual se convida o usuário a consulta-la periodicamente.
            </TermsText>
            <TermsText>
              1.4. A presente{' '}
              <label className="font-bold"> Política de Privacidade </label>
              tem por finalidade demonstrar o compromisso da CONTROLADORA com a
              privacidade e a proteção dos dados pessoais coletados através de
              seus portais eletrônicos, de acordo com a necessidade e a
              legislação vigente, ante a execução precípua de suas atividades
              evangelizadora, religiosa e social solidária.
            </TermsText>
            <TermsText>
              É de responsabilidade do usuário de usar todas as informações
              presentes no site com senso crítico, utilizando apenas como fonte
              de informação, e sempre buscando especialistas da área para a
              solução concreta do seu conflito.
            </TermsText>
            <TermsText title="2. DO ACESSO">
              2.1. Para acesso e uso das funcionalidades e conteúdo exclusivos
              dos portais eletrônicos da CONTROLADORA, o
              <label className="font-bold"> usuário,</label> declara o seu
              CONSENTIMENTO para coleta, armazenamento e compartilhamento de
              seus dados pessoais para os fins a que se destinam.
            </TermsText>
            <TermsText>
              2.2. Também são utilizados cookies e dados de navegação do usuário
              para traçar o seu perfil e poder proporcionar-lhe sempre a melhor
              experiência. Todo o processo é automatizado e não requer
              manipulação humana, mantendo a ética, integridade e autenticidade
              dos dados que mantidos nos cadastros enquanto houver tratamento.
            </TermsText>
            <TermsText>
              Ao acessar os PORTAIS da{' '}
              <Link
                to="https://www.6bios.com/pt/"
                target="_blank"
                className="font-bold underline"
              >
                www.6bios.com
              </Link>
              , o <label className="font-bold"> usuário</label> está plenamente
              ciente conferindo sua livre e expressa concordância com os termos
              aqui estipulados, sendo que, caso não esteja de acordo com estas
              diretivas, deverá descontinuar o seu acesso.
            </TermsText>

            <TermsText title="3. DOS DADOS COLETADOS, FORMA E FINALIDADE ">
              Este termo pode conter algumas palavras específicas que podem não
              se de conhecimento geral. Entre elas:
            </TermsText>
            <TermsText>
              3.1. Os dados são coletados quando o Usuário insere ou submete
              voluntariamente ao acessar e interagir com as funcionalidades
              disponibilizadas nos portais eletrônicos da CONTROLADORA.{' '}
            </TermsText>

            <table className="mb-4 w-full border-collapse border">
              <tr className="border border-black">
                <td className="border p-2">
                  Identificar o <label className="font-bold"> usuário</label>;
                </td>
              </tr>
              <tr className="border border-black">
                <td className="border p-2">
                  Informar sobre novidades, funcionalidades, conteúdos, notícias
                  e demais eventos relevantes para a manutenção do
                  relacionamento com o
                  <label className="font-bold"> usuário</label>;
                </td>
              </tr>
              <tr className="border border-black">
                <td className="border p-2">
                  Responder a solicitações e pedidos de informações do
                  <label className="font-bold"> usuário</label>;
                </td>
              </tr>
              <tr className="border border-black">
                <td className="border p-2">
                  Apresentar nossos projetos e parcerias.
                </td>
              </tr>
              <tr className="border border-black">
                <td className="border p-2">
                  Acessar a plataforma para patrocínio ou preservação das
                  propriedades cadastradas.
                </td>
              </tr>
              <tr className="border border-black">
                <td className="border p-2">
                  Fins estatísticos e de segurança;
                </td>
              </tr>
              <tr className="border border-black">
                <td className="border p-2">
                  Cumprimento de obrigações legais e regulatórias;
                </td>
              </tr>
            </table>

            <TermsText>
              3.2. É da responsabilidade exclusiva do
              <label className="font-bold"> usuário</label> a precisão,
              veracidade e atualização das informações prestadas nos portais
              eletrônicos da CONTROLADORA.
            </TermsText>
            <TermsText>
              3.3. Todas as tecnologias utilizadas respeitarão sempre a
              legislação vigente e os termos desta
              <label className="font-bold"> Política de Privacidade.</label>
            </TermsText>
            <TermsText>
              3.4. O consentimento que o
              <label className="font-bold"> usuário</label> fornece para as
              finalidades de uso dos dados é coletado de forma individual,
              clara, específica e legítima e não serão vendidas ou alugadas pela
              CONTROLADORA.
            </TermsText>
            <TermsText>
              3.5. Por meio do canal específico e exclusivo, o
              <label className="font-bold"> usuário</label> poderá alterar suas
              concessões de consentimento para tratamento de seus dados,
              conceder novas permissões ou retirar as permissões atuais.
            </TermsText>
            <TermsText>
              3.6. Os dados coletados e as atividades registradas também poderão
              ser compartilhados com outros setores/departamentos internos e/ou
              grupo
              <label className="font-bold">
                {' '}
                6BIOS – TECNOLOGIAS AMBIENTAIS SA,{' '}
              </label>
              para benefícios e informações relevantes aos
              <label className="font-bold"> usuários.</label>
            </TermsText>
            <TermsText>
              3.7. A base de dados formada por meio da coleta de dados nos
              portais da CONTROLADORA será de sua inteira e exclusiva
              propriedade e responsabilidade, sendo que seu uso, acesso e
              compartilhamento, quando necessários, serão feitos dentro dos
              limites e propósitos constantes dessa
              <label className="font-bold"> Política de Privacidade.</label> e
              de suas atividades desenvolvidas.
            </TermsText>
            <TermsText>
              3.8. O usuário é corresponsável pelo sigilo de seus dados
              pessoais. O compartilhamento de senhas e dados de acesso viola
              esta
              <label className="font-bold"> Política de Privacidade.</label>
            </TermsText>
            <TermsText>
              3.9. Internamente os dados coletados serão acessados somente por
              pessoas devidamente autorizadas, alocadas nos diversos Setores da
              CONTROLADORA, em estrito cumprimento as suas atividades
              profissionais, respeitando os princípios de proporcionalidade,
              necessidade e relevância para os objetivos específicos da coleta,
              além do compromisso de confidencialidade e preservação da
              privacidade nos termos desta
              <label className="font-bold"> Política de Privacidade.</label>
            </TermsText>
            <TermsText>
              3.10. Não serão enviados e-mails solicitando senhas aos
              <label className="font-bold"> usuários</label>, nem pedidos de
              encaminhamento dos seus dados cadastrais.
            </TermsText>
            <TermsText title="4. DO ARMAZENAMENTO DOS DADOS E REGISTROS ">
              4.1. Os dados coletados e os registros de atividades serão
              armazenados em ambiente seguro (servidores) e controlado. Os dados
              coletados serão armazenados em servidores localizados no Brasil,
              bem como em ambiente de uso de recursos ou servidores na nuvem
              (cloud computing), o que enseja, neste último caso, transferência
              ou processamento dos dados fora do Brasil.
            </TermsText>

            <TermsText title="5. DA EXIBIÇÃO, RETIFICAÇÃO, LIMITAÇÃO, OPOSIÇÃO E EXCLUSÃO DE DADOS ">
              5.1. O usuário pode solicitar a exibição, a retificação, a
              limitação, a oposição e a exclusão dos seus dados pessoais,
              através dos seguintes canais, criados exclusivamente para esses
              fins:
            </TermsText>
            <p>
              (i)
              <label className="font-bold">Por e-mail: </label>
              <span className="underline">adm@6bios.com;</span>
            </p>
            <TermsText>
              5.2. Em qualquer caso em que o
              <label className="font-bold"> usuário</label>, de alguma forma
              retire seu consentimento para finalidades fundamentais dos portais
              eletrônicos disponibilizados pela CONTROLADORA, os serviços e
              funcionalidades poderão ficar indisponíveis.
            </TermsText>
            <TermsText>
              5.3. Para fins de auditoria, segurança, controle de fraudes e
              preservação de direitos, o histórico de registro dos dados do
              <label className="font-bold"> usuário</label>, poderá permanecer
              armazenado por maior prazo nas hipóteses em que a lei ou norma
              regulatória assim estabelecer.
            </TermsText>

            <TermsText title="6.DA NEWSLETTER">
              6.1. Caso tenha se cadastrado para receber a newsletter no PORTAL:{' '}
              <a href="www.6bios.com">www.6bios.com</a>, o{' '}
              <span className="font-bold">usuário</span> concorda em receber
              notícias, publicidade personalizada sobre produtos entre outras
              informações.
            </TermsText>
            <TermsText>
              6.2. Ao se cadastrar para receber a newsletter do PORTAL{' '}
              <a href="www.6bios.com">www.6bios.com</a>, o{' '}
              <span className="font-bold">usuário</span> declara concordar com a
              realização de compilação personalizada de notícias, ofertas e
              outras informações, bem como avaliar os padrões de uso,
              objetivando personalizar as necessidades e interesses dos{' '}
              <span className="font-bold">usuários</span>.
            </TermsText>
            <TermsText>
              6.3. Caso o <span className="font-bold">usuário</span> não queira
              mais receber a newsletter do PORTAL{' '}
              <a href="www.6bios.com">www.6bios.com</a>, poderá cancelar o
              cadastro a qualquer momento através do link disponível para esse
              fim informado em os newsletters.
            </TermsText>
            <TermsText title="7.DOS COOKIES">
              7.1. Para facilitar o uso dos portais eletrônicos da CONTROLADORA,
              são utilizados “Cookies”. Cookies são pequenas unidades de dados
              armazenadas no disco rígido do computador do Usuário através do
              navegador.
            </TermsText>
            <TermsText>
              7.2. Os Cookies permitem que uma Plataforma Digital memorize
              informações sobre a visita dos Usuários, o seu idioma preferido, a
              sua localização, a recorrência das suas sessões e outras variáveis
              que os portais eletrônicos da CONTROLADORA considera relevantes
              para tornar a experiência muito mais eficiente. Esses Cookies
              também serão usados para ajudar a determinar a utilidade,
              interesse e o número de utilizações dos sites, permitindo uma
              navegação mais rápida e eliminando a necessidade de introduzir
              repetidamente as mesmas informações.{' '}
              <span className="font-bold">
                Eles não armazenam dados pessoais nem coletam informações de
                identificação pessoal.
              </span>
            </TermsText>
            <TermsText>
              7.3. A maioria dos navegadores de Internet são configurados para
              aceitar automaticamente os Cookies. O{' '}
              <span className="font-bold">usuário</span> poderá alterar as
              configurações para bloquear o uso de Cookies ou alertá-lo quando
              um Cookie estiver sendo enviado para seu dispositivo.
            </TermsText>
            <TermsText>
              7.4. Os <span className="font-bold">usuários</span> podem, a
              qualquer tempo desativar parte ou a totalidade dos Cookies.
            </TermsText>
            <TermsText>
              7.5. Todos os browsers (navegadores) permitem ao{' '}
              <span className="font-bold">usuário</span> configurar os Cookies,
              aceitando, recusando ou apagando, nomeadamente através da seleção
              das definições apropriadas no respectivo navegador (“opções” ou
              “preferencias”).
            </TermsText>
            <TermsText>
              7.6. Ao desativar Cookies, poderá impedir que alguns serviços da
              web funcionem corretamente, afetando, parcial ou totalmente, a
              navegação nos portais da CONTROLADORA.
            </TermsText>
            <TermsText title="8.DO OPERADOR, DO CONTROLADOR E DO ENCARREGADO – LGPD:">
              8.1. De acordo com a LGPD – Lei Federal 13.709/18, a 6BIOS –
              TECNOLOGIAS AMBIENTAIS SA não tem conflito de interesses com o
              ENCARREGADO, seguindo a boa observância da Lei, são eles:
              <br />
              (i) Independência para exercer suas obrigações; (ii) Não receber
              instruções sobre como exercer suas atividades; (iii) Não ser
              demitido ou punido por realizar suas funções; (iv) Reportar-se
              para a alta gestão/alta liderança da organização; (v) Não executar
              outras atividades que possam causar conflito de interesses.
            </TermsText>
            <table className="border">
              <tr className="border">
                <td className="border p-6">
                  AGENTE DE TRATAMENTO CONTROLADOR{' '}
                </td>
                <td className="pl-6">
                  6BIOS – TECNOLOGIAS AMBIENTAIS SA, pessoa Jurídica de Direito
                  Privado, inscrita sob registro CNPJ nº 51.583.770-0001-45,
                  dotada de autonomia patrimonial, administrativa e financeira,
                  com sede na Av. Faria Lima, 1811 – 11 andar, Conjunto 1119 –
                  Jardim Paulistano – São Paulo – SP, CEP: 014.52-001.{' '}
                </td>
              </tr>
              <tr className="border bg-slate-100">
                <td className="border p-6">Natureza dos dados tratados</td>
                <td className="pl-6">
                  Dados pessoais fornecidos pelo usuário e/ou coletados
                  automaticamente.
                </td>
              </tr>
              <tr className="border">
                <td className="border p-6">Finalidade como CONTROLADOR</td>
                <td className="pl-6">
                  Utilizar dados pessoais, envio de informações, produtos,
                  divulgação de eventos e realização de pesquisas, para os fins
                  a que se destina, em atenção a execução de suas atividades
                  empresariais. <br />
                  Base legal: • Consentimento do titular{' '}
                </td>
              </tr>
              <tr className="border bg-slate-100">
                <td className="border p-6">Compartilhamento</td>
                <td className="pl-6">
                  Interno entre setores, departamentos e filiais.
                </td>
              </tr>
              <tr className="border">
                <td className="border p-6">Proteção de Dados</td>
                <td className="pl-6">
                  Medidas de segurança, técnicas e administrativas, em
                  conformidade com a legislação da Lei 13.709/18.
                </td>
              </tr>
              <tr className="border bg-slate-100">
                <td className="border p-6">Seus direitos</td>
                <td className="pl-6">
                  Confirmação da existência de tratamento de dados, acesso,
                  correção, etc...
                </td>
              </tr>
            </table>
            <br />
            <TermsText title="9.DAS DISPOSIÇÕES GERAIS">
              9.1. Não são utilizadas nenhum tipo de decisão automatizada que
              impacte o <span className="font-bold">usuário</span>.
            </TermsText>
            <TermsText>
              9.2. A presente Política de Privacidade poderá ser alterada a
              qualquer momento, conforme a finalidade ou necessidade da
              CONTROLADORA, tal qual para adequação e conformidade legal de
              disposição de lei ou norma que tenha força jurídica equivalente,
              cabendo ao Usuário verificá-la sempre que efetuar o acesso em seus
              portais eletrônicos.
            </TermsText>
            <TermsText>
              9.3. Em caso de qualquer dúvida com relação às disposições
              constantes desta{' '}
              <span className="font-bold">Política de Privacidade</span>, o{' '}
              <span className="font-bold">usuário</span> poderá entrar em
              contato por meio dos canais de atendimento já descritos
              anteriormente.
            </TermsText>
            <TermsText>
              9.4. Caso empresas terceirizadas realizem o processamento de
              quaisquer dados coletados pela{' '}
              <span className="font-bold">
                6BIOS – TECNOLOGIAS AMBIENTAIS SA
              </span>
              , elas deverão, obrigatoriamente, respeitar as condições aqui
              estipuladas e as normas internas de Segurança da Informação.
            </TermsText>
            <TermsText>
              9.5. O Usuário reconhece que toda comunicação realizada por e-mail
              (aos endereços informados no seu cadastro), SMS, aplicativos de
              comunicação instantânea ou qualquer outra forma digital, virtual e
              digital também são válidas, eficazes e suficientes para a
              divulgação de qualquer assunto que se refira as atividades da
              CONTROLADORA, bem como às condições de sua prestação ou a qualquer
              outro assunto nele abordado, ressalvadas as disposições
              expressamente diversas previstas nesta Política de Privacidade.
            </TermsText>
            <TermsText title="10.DA APLICÁVEL E JURIDIÇÃO">
              10.1. Esta{' '}
              <span className="font-bold">Política de Privacidade</span> será
              regida, interpretada e executada de acordo com as Leis da
              República Federativa do Brasil, especialmente a Lei nº 13.709/2018
              (LGPD), independentemente das Leis de outros Estados ou Países,
              sendo competente o foro de domicílio da{' '}
              <span className="font-bold">
                6BIOS – TECNOLOGIAS AMBIENTAIS SA
              </span>{' '}
              para dirimir qualquer dúvida decorrente deste documento.
            </TermsText>
          </DialogDescription>
        </ScrollArea>
        <DialogFooter>
          <DialogClose asChild>
            <Button onClick={setAccepted}>Li e aceito os termos</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
